module.exports = __webpack_public_path__ + "static/media/VER.d8ba409e.png";